import {Injectable} from '@angular/core';
import {cloneDeep} from 'lodash';
import * as moment from "moment";

@Injectable()
export class FilterUtilityService {
    public cache = {};
    public counter = 0;

    constructor() {
    }

    addFilters(filters) {
        const ret = this.counter++;
        this.cache[ret + ''] = cloneDeep(filters);
        return ret;
    }

    getFilters(id) {
        return this.cache[id];
    }

    // Generates a JSON representation of the filters applied to the table
    getJsonFilters(tableOptions: any) {
        // Apply the filters if needed
        const tableFilters = [];
        if (!tableOptions.filters) {
            return JSON.stringify(tableFilters);
        }
        tableOptions.filters.forEach((filterRow, key) => {
            filterRow.forEach((filter) => {
                if (filter.value && filter.value.length !== 0) {
                    switch (filter.type) {
                        case 'assessor':
                        case 'text':
                        case 'number':
                        case 'checkbox':
                            if (typeof filter.emptyValue === 'undefined' || filter.value === 'true') {
                                if (typeof filter.generateTrueValue === 'function') {
                                    tableFilters.push({property: filter.id, value: filter.generateTrueValue()});
                                } else {
                                    tableFilters.push({property: filter.id, value: filter.value});
                                }
                            } else {
                                if (filter.emptyValue != null) {
                                    tableFilters.push({property: filter.id, value: filter.emptyValue});
                                }
                            }
                            break;
                        case 'date':
                            tableFilters.push({
                                property: filter.id,
                                value: moment(filter.value).format('YYYY-MM-DD')
                            });
                            break;
                        case 'combobox':
                        case 'multicombobox':
                            const valMulti = [];
                            filter.value.forEach((selection) => {
                                valMulti.push(selection.id);
                            });
                            tableFilters.push({property: filter.id, value: valMulti.toString()});
                            break;
                        case 'ouRu':
                            if (filter.value) {
                                const val = [];
                                filter.value.forEach((selection) => {
                                    val.push(' ' + selection.code + ':' + selection.id);
                                });
                                tableFilters.push({property: filter.id, value: val.toString()});
                            }
                            break;
                    }
                }
            });

            if (tableOptions.inlineFilter && tableOptions.inlineFilter.value) {
                tableFilters.push({
                    property: tableOptions.inlineFilter.id,
                    value: tableOptions.inlineFilter.value
                });
            }
        });
        return JSON.stringify(tableFilters);
    }

    getAssessorJsonFilters(assessorFilterOptions: any) {
        // Apply the filters if needed
        const assessorFilters = [];
        assessorFilterOptions.filters.forEach((filterRow, key) => {
            filterRow.forEach((filter: any) => {
                if (filter.value != null && filter.value !== '') {
                    switch (filter.type) {
                        case 'text':
                        case 'checkbox':
                            if (typeof filter.emptyValue === 'undefined' || filter.value === 'true') {
                                if (typeof filter.generateTrueValue === 'function') {
                                    assessorFilters.push({property: filter.id, value: filter.generateTrueValue()});
                                } else {
                                    assessorFilters.push({property: filter.id, value: filter.value});
                                }
                            } else {
                                if (filter.emptyValue !== null) {
                                    assessorFilters.push({property: filter.id, value: filter.emptyValue});
                                }
                            }
                            break;
                    }
                }
            });
        });
        return JSON.stringify(assessorFilters);
    };

}
